export function getFilenamePostfix() {
  const date = new Date();

  const appendZero = (val: number) => (val < 10 ? "0" + val : val);

  const year = date.getFullYear();
  const month = appendZero(date.getMonth() + 1);
  const day = appendZero(date.getDate());
  const hour = appendZero(date.getHours());
  const min = appendZero(date.getMinutes());
  const sec = appendZero(date.getSeconds());
  const ms = appendZero(date.getMilliseconds());

  return `${year}-${month}-${day}-${hour}-${min}-${sec}-${ms}`;
}
